import { useLatestEntity } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import type { AgentModel } from '@models/types'

export const useRelations = (agent: Partial<AgentModel> = {}) => {
  const { user_id } = agent

  const { images, users } = useSelector(reduxState => reduxState.entities)

  const user = user_id && users[user_id] ? users[user_id] : {}
  // @ts-expect-error TS2339
  const image = user.image_id && images[user.image_id] ? images[user.image_id] : {}

  return {
    image,
    user,
  }
}

function useAgent(initEntity: Partial<AgentModel> = {}) {
  // @ts-expect-error TS2322
  const { entity: agent }: { entity: AgentModel } = useLatestEntity(initEntity, 'agents')

  const { image, user } = useRelations(agent)

  const { loadedIds, loading } = useSelector(reduxState => reduxState.agents)

  return {
    agent,
    image,
    loading: loading && !loadedIds.includes(agent.id),
    user,
  }
}

export default useAgent
